import React from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { purchaseRequestApi } from '../../api';
import { PurchaseRequest } from '../../types';

/**
 * 대리구매 추가 청구 결제 블록. 대리구매 페이지 / 마이페이지 양쪽에서 재사용.
 * 추가 청구가 없으면 아무것도 렌더하지 않는다.
 */
const ExtraChargePayment: React.FC<{ request: PurchaseRequest; onPaid: () => void }> = ({ request, onPaid }) => {
  const amount = request.extraChargeUsd ?? 0;
  if (amount <= 0) return null;

  if (request.extraChargePaid) {
    return (
      <div style={styles.box}>
        <div style={{ fontWeight: 600, color: '#2e7d32' }}>추가 청구 ${amount.toFixed(2)} 결제완료 ✓</div>
        {request.extraChargeReason && <div style={styles.reason}>{request.extraChargeReason}</div>}
      </div>
    );
  }

  return (
    <div style={styles.box}>
      <div style={{ fontWeight: 700, color: '#e65100' }}>추가 청구: ${amount.toFixed(2)}</div>
      {request.extraChargeReason && <div style={styles.reason}>{request.extraChargeReason}</div>}
      <div style={{ marginTop: 10 }}>
        <PayPalButtons
          forceReRender={[request.id, amount]}
          style={{ layout: 'horizontal', height: 40 }}
          createOrder={async () => {
            const res = await purchaseRequestApi.createExtraPayPalOrder(request.id);
            return res.data.data.paypalOrderId;
          }}
          onApprove={async (data) => {
            await purchaseRequestApi.captureExtraPayPal(request.id, data.orderID!);
            alert('추가 결제 완료!');
            onPaid();
          }}
          onError={() => alert('PayPal 오류가 발생했습니다.')}
        />
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  box: { background: '#fff8f0', border: '1px solid #ffe0b2', borderRadius: 8, padding: '12px 14px', marginTop: 10 },
  reason: { fontSize: 12, color: '#888', marginTop: 4 },
};

export default ExtraChargePayment;
